import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Link from './Link';
import Price from './Price';

const ProductListItem = ({ product }) => {
  const { locale } = useIntl();

  const product_link = `/${locale}/view/${product.product_id}/${product.title}`;

  return (
    <Container className="grid-item">
      <ImageLink to={product_link}>
        <img src={product.list_image_src} alt={product.title} />
      </ImageLink>
      <Info to={product_link}>
        <span>{product.title}</span>
        <Price price={product.price_with_frame} />
      </Info>
    </Container>
  )
};

export default ProductListItem;

const Container = styled.div`
    /*width: calc(${props => props.landscape ? '50%' : '25%'} - 1rem);*/
    width: calc(32% - 1rem);
    margin: 0.5rem;
    padding: 0.5rem;
    background-color: white;
    box-shadow: 0px 4px 18px -9px rgba(92,105,128,0.75);
    -webkit-box-shadow: 0px 4px 18px -9px rgba(92,105,128,0.75);
    -moz-box-shadow: 0px 4px 18px -9px rgba(92,105,128,0.75);

    @media (max-width: 1000px) {
        width: calc(100% - 1rem);
    }
`;

const ImageLink = styled(Link)`
    overflow: hidden;
    display: block;

    img {
        width: 100%;
        transition: transform .5s ease;

        &:hover {
            transform: scale(1.75);
        }
    }
`;

const Info = styled(Link)`
    display: flex;
    justify-content: space-between;
    padding-top: 3px;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    align-items: center;
    gap: 5px;

    span {
      width: 100%;
    }

    ${Price} {
        color: #555;
        font-weight: 600;
        text-align: right
    }
`;
